import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TrackingUtils } from '../../utils';

export function Tooltip({ position, text, type, style, tracking }) {
    useEffect(() => {
        if (tracking) {
            TrackingUtils.trackEvent({ action: TrackingUtils.ACTION.PRODUCT_SELECTOR, label: tracking });
        }
    }, [tracking]);

    return (
        <span
            className={`odf-tooltip odf-tooltip-${type} odf-tooltip-top-${position} odf-text-nowrap`}
            dangerouslySetInnerHTML={{ __html: text }}
            style={{ ...style }}
        />
    );
}

Tooltip.propTypes = {
    position: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    style: PropTypes.object,
    tracking: PropTypes.string,
};

Tooltip.defaultProps = {
    style: {},
};
